import { Box } from '@mui/material';
import { forwardRef, ReactNode } from 'react';

const ClickHandler = forwardRef(
  (
    {
      onClick,
      children
    }: {
      onClick: () => void;
      children: ReactNode | ReactNode[];
    },
    ref
  ) => {
    return (
      <Box ref={ref} onClick={onClick}>
        {children}
      </Box>
    );
  }
);

export default ClickHandler;
